import React, { useEffect, useState } from 'react';
import img from "../../assets/images/flat.jpg";
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { API_URL } from '../../common/constant';
import './Rent.css';
import BottomNav from '../../component/BottomNav';
import { FaCheckCircle } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import FreeListing_property from '../../component/FreeListing_property';
import Loader from '../../component/loader/Loader';
import WhatsAppButton from '../../component/Whatsappbtn';
import FAQ from '../../component/FAQ/FAQ';


const RentPropertyList = () => {

    const [properties, setProperties] = useState([]); // State to store fetched data
    // const [loading, setLoading] = useState(true);
    const [loading, setLoading] = useState(true);

    const phoneNumber = '8318150076';
    const navigate = useNavigate();

    const handleWhatsappClick = (event) => {
        event.stopPropagation(); // Prevent parent onClick from firing
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };



 
    const handleNavigate = (propertyId) => {
        navigate(`/for-rent-property/${propertyId}`); // Send property ID as a parameter
    };

    const handleCallClick = (event) => {
        event.stopPropagation(); // Prevent parent onClick from firing
        // No additional logic needed for <a> tags as they handle navigation
    };

    useEffect(() => {
        const fetchProperties = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/society-rent/all-societies`);
                setProperties(response.data.societies); // Update state with fetched data
                setLoading(false); 
            } catch (error) {
                console.error("Error fetching properties:", error);
                setLoading(false); // Hide the loader in case of error
            }
        };

        fetchProperties();
    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <>

            <Helmet>
                <title>Properties for Rent in Lucknow | Affordable Flats & Apartments</title>
                <meta name="description" content="Find the best rental properties in Lucknow. Explore affordable 1BHK, 2BHK, and 3BHK apartments with modern amenities. Contact us now!" />
                <meta name="keywords" content="rent property Lucknow, flats for rent, apartments for rent, 1BHK, 2BHK, rental houses" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Placezio Estate" />
                <link rel="canonical" href="https://placezioestate.com/rent-list" />

            </Helmet>
            <div className="relative p-2 mx-4 flex flex-wrap gap-8">

                {/* Dynamic Property List */}
                <div className="w-full md:w-100 lg:w-2/3 sm:w-100 flex flex-col gap-8">
                    <h1 className='py-4 text-[#54BD95] text-4xl font-bold mx-8'>Best Societies for Rent in Lucknow</h1>


                    {properties.map((property) => (
                        <div
                            key={property._id}
                            className="bg-white shadow-lg p-6 rounded-lg transition-all hover:shadow-xl hover:scale-105 cursor-pointer flex flex-col lg:flex-row"
                            onClick={() => handleNavigate(property._id)} // Pass property ID
                        >
                            {/* Property Image Section */}
                            <div className="mb-6 lg:mb-0 lg:w-1/3">
                                <img
                                    src={`${API_URL}/uploads/societyRent/${property._id}/${property.mainImage}`}
                                    alt="Property"
                                    className="h-60 w-full object-cover rounded-lg shadow-md transform transition-all duration-500 hover:scale-105"
                                />
                            </div>

                            {/* Property Details Section */}
                            <div className="lg:ml-6 text-gray-800 lg:w-2/3">
                                <h2 className="text-2xl font-semibold mb-2 hover:text-[#54BD95]">{property.name}</h2>
                                <p className="text-sm text-gray-500 mt-2">{property.address || "Available in Lucknow, Uttar Pradesh"}</p>

                                <div className="mt-4 space-y-2">
                                    <div className="flex  items-center">
                                        <p className="text-sm font-medium">Facilities:</p>
                                        <p className="text-sm text-gray-600 ml-4"> {property.facilities?.slice(0, 5).join(', ') || "Fully furnished, 24/7 water supply, Security, Parking"}</p>
                                    </div>

                                    <div className="flex  items-center">
                                        <p className="text-sm font-medium">Price Start from:</p>
                                        <p className="text-lg font-bold text-[#54BD95] ml-4">₹{property.one_bhk_rent || "18,000"}/month</p>
                                    </div>

                                    <div className="flex  items-center">
                                        <p className="text-sm font-medium">Available:</p>
                                        <p className="text-sm text-gray-600 ml-4">{"Starting from 1 BHK"}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Pad Section */}
                            <div className="mt-6 space-y-4 lg:space-y-0 lg:mt-0 lg:ml-6 lg:flex-row lg:items-center gap-4">
                                {/* WhatsApp Button */}
                                <button
                                    onClick={handleWhatsappClick}
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6 rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 my-6 py-2"
                                >
                                    <FaWhatsapp className="text-white mr-2" size={20} />  {/* Reduced margin */}
                                    <span className="text-lg">WhatsApp</span>
                                </button>


                                {/* Contact Owner Button */}
                                <a
                                    href={`tel:${phoneNumber}`}
                                    onClick={handleCallClick} // Prevent navigation propagation
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6  rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 mt-6 py-2"
                                >
                                    <FaPhoneAlt className="text-white mr-3" size={20} />
                                    <span className="text-lg">Contact</span>
                                </a>
                            </div>

                        </div>
                    ))}



                </div>

                {/* Static Sidebar Section - List your Property */}
                {/* <div className="w-full md:w-80 sm:w-full mt-24 md:mt-24  bg-green-100 shadow-md md:mx-8">
                    <div className='text-center mt-4'>
                        <h1 className='text-3xl mx-8'>List your Property<br />
                            <span className='text-red-700 font-bold'>free</span> on <br></br><span className='text-[#54BD95] font-bold'>Placezio Estate</span>
                        </h1>
                    </div>

                    <div className='mt-8 text-center'>
                        <button className='bg-[#54BD95] w-52 text-white p-2 rounded-lg ' onClick={list_property}>Post property</button>
                    </div>



                    <div className='mt-8 px-4'>
                        <h1 className='text-3xl text-center'>What's your Benefit</h1>
                        <div className='mt-6'>
                            <div className="flex items-center space-x-3">
                                <FaCheckCircle className="text-[#54BD95]" size={20} />
                                <p className='my-2 text-lg'>Faster Deals</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaCheckCircle className="text-[#54BD95]" size={20} />
                                <p className='my-2 text-lg'>Cost-Free Registration</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaCheckCircle className="text-[#54BD95]" size={20} />
                                <p className='my-2 text-lg'>24/7 Online Availability</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaCheckCircle className="text-[#54BD95]" size={20} />
                                <p className='my-2 text-lg'>Professional Presentation</p>
                            </div>
                        </div>
                    </div> */}

                {/* </div> */}
                <FreeListing_property/>
                <WhatsAppButton/>
                <div className='w-full'>
                <FAQ/>
                </div>
               
                <BottomNav />
            </div>
            
        </>


    );

};

export default RentPropertyList;
